
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing",
      function () {
        return require("private-next-pages/landing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing"])
      });
    }
  